<template>
  <footer class="footer">
    <p class="footer__copyright">
      Copyright(c)2020 UILab All rights reserved.
    </p>
  </footer>
</template>

<script>
export default {
	name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer{
  width:100%;
  text-align: center;
  height:72px;
  padding:25px 0;
  &__copyright{
    width:100%;
    font-size: 13px;
    line-height: 1.69;
    letter-spacing: normal;
    color: #666666;
  }
}
</style>